/* Rince — 3D onderdeel-viewer (LINE-ART). Toont één los onderdeel als
   lijntekening op de donkere Rince-achtergrond — of de complete set.
   Modellen: 'capsule' (vitamine C, amber kern — bewuste merk-uitzondering),
   'filter' (standaard cartridge), 'longlife' (hoge capaciteit) en 'family'
   (douchekop + filter + longlife + capsule naast elkaar, synchroon draaiend).
   Zelfde familie-patronen als de andere 3D-secties: Three.js lazy geladen
   (self-hosted, CDN-fallback), IntersectionObserver-init, sleep-rotatie +
   auto-rotate, reduced-motion toont een statisch beeld, render pauzeert
   buiten beeld. Verhoudingen uit de leveranciersfoto's:
     douchekop 340 mm · longlife 148×25 mm · filter 86,5×25 mm · capsule 71×31 mm */
(function () {
  var CDN = window.__RINCE_THREE_SRC || 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
  var p = null;
  /* PERFORMANCE: op mobiel pas laden na het load-event + idle, zodat de ~589 KB
     Three.js-bundel niet concurreert met FCP/LCP. Desktop laadt direct door. */
  function loadThree(){ if(window.THREE) return Promise.resolve(window.THREE); if(p) return p;
    p = new Promise(function(res,rej){
      var go = function(){ var s=document.createElement('script'); s.src=CDN; s.async=true; s.onload=function(){res(window.THREE);}; s.onerror=function(){rej(new Error('three'));}; document.head.appendChild(s); };
      if (window.__rinceDefer3D && window.__rinceWhenIdle) window.__rinceWhenIdle(go); else go();
    }); return p; }

  function build(TH, canvas, root){
    var reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var mobile = (window.innerWidth||1024) < 700;
    var autoOn = root.getAttribute('data-part-autorotate') !== 'false';
    var which = root.getAttribute('data-part-model') || 'filter';

    var renderer = new TH.WebGLRenderer({canvas:canvas, antialias:true, alpha:true});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1, mobile?1.5:2));
    renderer.setClearColor(0x000000,0);

    var scene = new TH.Scene();
    var camera = new TH.PerspectiveCamera(30,1,0.1,50);

    /* line materials — familiepalet */
    var inkMat   = new TH.LineBasicMaterial({color:0xc4ccd3, transparent:true, opacity:0.6});
    var softMat  = new TH.LineBasicMaterial({color:0x8b949d, transparent:true, opacity:0.32});
    var fineMat  = new TH.LineBasicMaterial({color:0x9aa3ac, transparent:true, opacity:0.16});
    var accent   = new TH.LineBasicMaterial({color:0x5c7a95, transparent:true, opacity:0.9});
    var amberLn  = new TH.LineBasicMaterial({color:0xe9c25c, transparent:true, opacity:0.85});   // vit-C (uitzondering)
    var amberFill= new TH.MeshBasicMaterial({color:0xf2c14e, transparent:true, opacity:0.10, side:TH.DoubleSide, depthWrite:false});

    var tilt = new TH.Group(); scene.add(tilt);
    var spin = new TH.Group(); tilt.add(spin);

    /* ---------- helpers — bouwen in `target` zodat sub-groepen mogelijk zijn ---------- */
    var target = spin;
    function latRing(r, y, n, mat){ var pts=[],i; for(i=0;i<n;i++){var a=i/n*Math.PI*2; pts.push(Math.cos(a)*r, y, Math.sin(a)*r);} var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3)); var l=new TH.LineLoop(g,mat); target.add(l); return l; }
    function vline(x,z,y0,y1,mat){ var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute([x,y0,z, x,y1,z],3)); target.add(new TH.Line(g,mat)); }
    function fibers(r, y0, y1, n, mat){ for(var i=0;i<n;i++){ var a=i/n*Math.PI*2; vline(Math.cos(a)*r, Math.sin(a)*r, y0, y1, mat); } }
    function rrect(y, hw, hd, mat){ var r2=Math.min(hw,hd)*0.42, pts=[], N=40;
      for(var i=0;i<N;i++){ var t=i/N*Math.PI*2, cx=Math.cos(t), cz=Math.sin(t);
        var x=Math.max(-1,Math.min(1,cx*1.35))*(hw-r2)+cx*r2, z=Math.max(-1,Math.min(1,cz*1.35))*(hd-r2)+cz*r2;
        pts.push(x,y,z); }
      var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3));
      var l=new TH.LineLoop(g,mat); target.add(l); return l; }
    /* ovale ring in het verticale vlak (facing ±Z), voor de douchekop */
    function ovalRing(rx, ry, cy, z, n, mat){ var pts=[],i; for(i=0;i<n;i++){var a=i/n*Math.PI*2; pts.push(Math.cos(a)*rx, cy+Math.sin(a)*ry, z);} var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute(pts,3)); var l=new TH.LineLoop(g,mat); target.add(l); return l; }

    /* ---------- model-bouwers (elk gecentreerd rond y=0, retourneert halve hoogte) ---------- */
    function buildCapsule(){
      [-0.52,-0.26,0,0.26,0.52].forEach(function(y){ rrect(y, 0.30, 0.235, softMat); });
      rrect(0.60, 0.30, 0.235, inkMat); rrect(-0.60, 0.30, 0.235, inkMat);      // lijf-randen
      rrect(0.66, 0.325, 0.255, inkMat); rrect(0.70, 0.325, 0.255, softMat);    // platte top-flens
      rrect(-0.66, 0.315, 0.245, inkMat); rrect(-0.72, 0.34, 0.265, inkMat);    // uitstekende voet
      [Math.PI*0.2, Math.PI*0.8, Math.PI*1.2, Math.PI*1.8].forEach(function(a){
        vline(Math.cos(a)*0.285, Math.sin(a)*0.22, -0.60, 0.60, softMat); });
      // amber vulling: de vitamine C-pasta, zichtbaar door het melkwitte omhulsel
      var core=new TH.Mesh(new TH.BoxGeometry(0.42,0.92,0.32), amberFill); target.add(core);
      [-0.40,-0.20,0,0.20,0.40].forEach(function(y){ rrect(y, 0.215, 0.165, amberLn); });
      [Math.PI*0.25, Math.PI*0.75, Math.PI*1.25, Math.PI*1.75].forEach(function(a){
        vline(Math.cos(a)*0.195, Math.sin(a)*0.15, -0.44, 0.44, amberLn); });
      rrect(0.46, 0.215, 0.165, amberLn); rrect(-0.46, 0.215, 0.165, amberLn);
      return 0.78;
    }
    function buildLonglife(){
      var R2=0.17;                                                    // h/d ≈ 5,9 — extreem slank
      latRing(R2, 0.82, 32, inkMat); latRing(R2, -0.94, 32, inkMat);  // lijf-randen
      fibers(R2, -0.92, 0.80, 44, fineMat);                           // koolstofvezel-lijf
      [-0.48,0,0.44].forEach(function(y){ latRing(R2, y, 30, softMat); });
      // schroefkraag met 3 ribbels (zoals de foto) + steel accent op de onderste
      latRing(0.225, 0.86, 28, inkMat); latRing(0.225, 0.92, 28, inkMat); latRing(0.225, 0.98, 28, inkMat);
      latRing(0.20, 1.02, 26, softMat);                               // kraag-top
      latRing(0.225, 0.84, 28, accent);
      // voetstuk
      latRing(0.195, -0.98, 26, inkMat); latRing(0.195, -1.04, 26, softMat);
      return 1.05;
    }
    function buildFilter(){
      var R3=0.21;                                                    // h/d ≈ 3,5
      latRing(R3, 0.60, 32, inkMat); latRing(R3, -0.60, 32, inkMat);  // lijf-randen
      fibers(R3, -0.58, 0.58, 36, fineMat);                           // vezel-lijf
      [-0.30,0,0.30].forEach(function(y){ latRing(R3, y, 30, softMat); });
      // brede platte flenzen boven + onder (transparante schijven op de foto)
      latRing(0.285, 0.64, 32, inkMat); latRing(0.285, 0.68, 32, softMat);
      latRing(0.285, -0.64, 32, inkMat); latRing(0.285, -0.68, 32, softMat);
      // nippel bovenop
      latRing(0.075, 0.72, 20, inkMat); latRing(0.075, 0.80, 20, inkMat);
      vline(0.075, 0, 0.72, 0.80, softMat); vline(-0.075, 0, 0.72, 0.80, softMat);
      // steel accent op de ondervoet
      latRing(0.24, -0.66, 28, accent);
      return 0.80;
    }
    /* douchekop — staand, zoals de productfoto: ovale kop, tapse steel, knurl-grip */
    function buildHead(){
      var CY=0.72;                                                     // kop-centrum
      [0.10,-0.10].forEach(function(z){ ovalRing(0.30, 0.40, CY, z, 40, inkMat); });   // buitenrand (dikte)
      [0.10,-0.10].forEach(function(z){ ovalRing(0.17, 0.27, CY, z, 32, softMat); });  // binnenrand (holte)
      ovalRing(0.235, 0.335, CY, 0.115, 36, accent);                   // sproeiring (steel accent, voorvlak)
      // dikte-verbindingen op 4 punten
      [0, Math.PI*0.5, Math.PI, Math.PI*1.5].forEach(function(a){
        var x=Math.cos(a)*0.30, y=CY+Math.sin(a)*0.40;
        var g=new TH.BufferGeometry(); g.setAttribute('position',new TH.Float32BufferAttribute([x,y,0.10, x,y,-0.10],3));
        target.add(new TH.Line(g,inkMat)); });
      // steel: licht taps, met amber vitamine C-venster en knurl-grip
      latRing(0.145, 0.30, 26, inkMat);
      fibers(0.138, -0.70, 0.28, 4, softMat);
      [0.06,-0.18,-0.42].forEach(function(y){ latRing(0.14, y, 24, softMat); });
      latRing(0.132, -0.28, 24, amberLn); latRing(0.132, -0.44, 24, amberLn);   // vit-C venster
      var win=new TH.Mesh(new TH.CylinderGeometry(0.128,0.128,0.16,20,1,true), amberFill);
      win.position.y=-0.36; target.add(win);
      // knurl-grip: dichte ribbelringen
      [-0.74,-0.80,-0.86,-0.92].forEach(function(y){ latRing(0.142, y, 24, softMat); });
      latRing(0.14, -0.70, 24, inkMat); latRing(0.138, -0.96, 24, inkMat);
      // schroefdraad-tip
      latRing(0.075, -1.02, 18, inkMat); latRing(0.075, -1.12, 18, softMat);
      vline(0.075, 0, -1.02, -1.12, softMat); vline(-0.075, 0, -1.02, -1.12, softMat);
      return 1.15;
    }

    /* ---------- opbouw: één model, of de complete set ---------- */
    var H, partGroups = [spin];
    if (which === 'family'){
      // vier onderdelen naast elkaar, onderkanten uitgelijnd; elk draait om z'n eigen as
      partGroups = [];
      var BASE = -1.05;   // gemeenschappelijke grondlijn
      [ { build: buildHead,     x: -1.15, s: 1.00 },
        { build: buildFilter,   x: -0.10, s: 0.62 },
        { build: buildLonglife, x:  0.55, s: 0.62 },
        { build: buildCapsule,  x:  1.22, s: 0.60 }
      ].forEach(function(part){
        var g = new TH.Group();
        target = g;
        var h = part.build();
        g.scale.setScalar(part.s);
        g.position.set(part.x, BASE + h*part.s, 0);
        spin.add(g); partGroups.push(g);
      });
      target = spin;
      H = 1.30;
    } else if (which === 'capsule'){ H = buildCapsule(); }
    else if (which === 'longlife'){ H = buildLonglife(); }
    else if (which === 'head'){ H = buildHead(); }
    else { H = buildFilter(); }

    tilt.rotation.x = 0.12;

    /* ---------- interactie: slepen + auto-rotate ---------- */
    var autoRot=0, dragRot=0, dragTilt=0.12, dragging=false, px=0, py=0;
    canvas.addEventListener('pointerdown',function(e){dragging=true;px=e.clientX;py=e.clientY;try{canvas.setPointerCapture(e.pointerId);}catch(_){} play();},{passive:true});
    canvas.addEventListener('pointermove',function(e){if(!dragging)return;dragRot+=(e.clientX-px)*0.008;dragTilt+=(e.clientY-py)*0.004;dragTilt=Math.max(-0.35,Math.min(0.45,dragTilt));px=e.clientX;py=e.clientY;},{passive:true});
    canvas.addEventListener('pointerup',function(){dragging=false;},{passive:true});

    var fam = (which === 'family');
    var dist = fam ? 6.2 : H*4.9;
    var camY = fam ? 0.55 : H*0.25;
    var lookY = fam ? 0.08 : 0;
    /* Camera-fit: bij de complete set bepaalt de smalste as (hoogte óf breedte,
       afhankelijk van de podium-verhouding) de afstand — vult elk formaat optimaal. */
    var TAN_HALF_FOV = Math.tan(Math.PI/12); // fov 30°
    function fit(){
      if (!fam) return;
      var needH = 1.32, needW = 1.58; // halve content-hoogte/-breedte + marge
      dist = Math.max(needH/TAN_HALF_FOV, needW/(TAN_HALF_FOV*camera.aspect));
    }
    function resize(){var w=canvas.clientWidth||1,h=canvas.clientHeight||1;renderer.setSize(w,h,false);camera.aspect=w/h;camera.updateProjectionMatrix();fit();}
    function frame(){
      if(!reduced && !dragging && autoOn) autoRot+=0.0035;
      var rot = 0.5 + dragRot + autoRot;
      if (fam){ partGroups.forEach(function(g){ g.rotation.y = rot; }); }
      else { spin.rotation.y = rot; }
      tilt.rotation.x = dragTilt;
      camera.position.set(0, camY, dist); camera.lookAt(0, lookY, 0);
      renderer.render(scene,camera);
    }
    var rafId=null, active=true;
    function tick(){ frame(); if(reduced && !dragging){ rafId=null; return; } rafId=requestAnimationFrame(tick); }
    function play(){ if(active && rafId==null) rafId=requestAnimationFrame(tick); }
    function pause(){ if(rafId!=null){ cancelAnimationFrame(rafId); rafId=null; } }
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ active=es[0].isIntersecting; if(active) play(); else pause(); },{rootMargin:'150px'}).observe(canvas); }
    document.addEventListener('visibilitychange', function(){ if(document.hidden) pause(); else play(); });
    var rT; window.addEventListener('resize', function(){ clearTimeout(rT); rT=setTimeout(function(){ resize(); play(); },150); },{passive:true});
    resize(); play(); canvas.classList.add('is-ready');
  }

  function init(root){
    if(root.dataset.partInit) return; root.dataset.partInit='1';
    var canvas=root.querySelector('[data-part-canvas]'); if(!canvas) return;
    var loader=root.querySelector('[data-part-loader]');
    loadThree().then(function(TH){ build(TH,canvas,root); if(loader) loader.classList.add('gone'); })
      .catch(function(){ if(loader) loader.classList.add('gone'); root.setAttribute('data-part-failed',''); });
  }
  function arm(root){
    function near(){ var r=root.getBoundingClientRect(); return r.top<(window.innerHeight+600)&&r.bottom>-600; }
    if(near()){ init(root); return; }
    if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ io.disconnect(); init(root); } });},{rootMargin:'400px'}); io.observe(root); } else init(root);
  }
  function boot(){ document.querySelectorAll('[data-rx-part]').forEach(arm); }
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ if(e.target&&e.target.querySelectorAll) e.target.querySelectorAll('[data-rx-part]').forEach(arm); });
})();
